/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import ReactApexChart from "react-apexcharts";

/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'

export class UnrelatedKeywordChart extends Component {
    static displayName = UnrelatedKeywordChart.name;

    constructor(props) {
        super(props);

        const self = this;

        this.state = {           
            mode: Constants.MODE_LOADING,
            options: self.getChartOptions(),
            series: []
        }
    }

    getChartOptions(title, labels) {

        return {
            labels: labels || [],
            colors: ['#d4526e', '#c1c1c1'],
            responsive: [{
                breakpoint: 1500,
                options: {
                    chart: {
                        width: 320,
                        height: 220
                    },
                    plotOptions: {
                        radialBar: {
                            hollow: {
                                size: '60%',
                            }
                        }
                    },
                }
            }],
            tooltip: {
                fillSeriesColor: false,
                theme: 'light',
                y: {
                    formatter: function (val, index) {
                        let valPercent = val + '%';
                        return valPercent;
                    }
                } 
            },
            legend: {
                    show: false,
                    fontWeight: 100,
                    formatter: function (labels, opts) {
                        return [labels, " - ", opts.w.globals.series[opts.seriesIndex]]
                    }
            },
            title: {
                text: title || 'Loading...',
                align: 'left',
                floating: true,
                style: {
                    fontSize: '20px',
                    fontWeight: 100,
                    color: '#404040'
                },
            },
            subtitle: {
                text: 'Unrelated Keywords',
                floating: true,
                margin: 5,
                align: 'left',
                style: {
                    fontWeight: 100
                }
            }
        }
    };


    load() {

        const self = this;

        ajax.get(Constants.ROUTE_API_DASHBOARD_UNRELATED_KEYWORDS,
            {
                success: function (response) {

                    let seriesLabel = ['Unrelated Keywords', 'Related keywords'];

                    self.setState({
                        mode: Constants.MODE_LOADED,
                        options: self.getChartOptions(typing.numberWithCommas(response.data[0].SUMMATION), seriesLabel),
                        series: [response.data[0].PERCENTAGE, 100 - response.data[0].PERCENTAGE],
                        seriesLabel: seriesLabel
                    });
                }
            });
    };

    componentDidMount() {
        const self = this;
        self.load();
    };


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        return (
          <Fragment>
          <div className="chart-container">
            <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height={332}  />
          </div>
        </Fragment>
        )
    }
}



    

   
